module.exports = __webpack_public_path__ + "static/media/switch-on.8349e14d.svg";